import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./i18n";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import CoursePlayer from "./pages/CoursePlayer";
import Journey from "./pages/Journey";
import TrainerDashboard from "./pages/TrainerDashboard";
import Admin from "./pages/Admin";
import Home from "./pages/Home";

const HomeGate: React.FC = () => {
  const { user } = useAuth();
  if (user === null) return <div className="p-12 text-muted-foreground">…</div>;
  if (user === false) return <Home />;
  if (user.force_password_change) return <Navigate to="/login" replace />;
  return <Layout><Dashboard /></Layout>;
};

const Protected: React.FC<{ children: React.ReactNode; roles?: string[] }> = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-12 text-muted-foreground">…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.force_password_change) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.system_role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<HomeGate />} />
            <Route path="/courses" element={<Protected><Courses /></Protected>} />
            <Route path="/courses/:courseId" element={<Protected><CoursePlayer /></Protected>} />
            <Route path="/journey" element={<Protected><Journey /></Protected>} />
            <Route path="/trainer" element={<Protected roles={["TRAINER", "FORMATEUR", "CORPORATE_TRAINER", "ACADEMY_ADMIN", "ADMIN", "SUPER_ADMIN", "OWNER"]}><TrainerDashboard /></Protected>} />
            <Route path="/admin" element={<Protected roles={["ACADEMY_ADMIN", "ADMIN", "SUPER_ADMIN", "OWNER"]}><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
